<div class="container">
    <div class="artwork">
        <img src="../../../../../assets/images/auth.png">
    </div>
    <div class="content">
         <router-outlet></router-outlet>
    </div>
</div>
